import axios from 'axios'
import qs from 'qs'
import store from '@/store'

const client = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: true,
  paramsSerializer: params => qs.stringify(params, { indices: false, skipNulls: true })
})

client.interceptors.request.use(function (config) {
  if (document.cookie) {
    const csrfCookie = document.cookie.split(';').find((c) => { return c.trim().startsWith('csrftoken=') })
    if (csrfCookie) {
      const csrfToken = csrfCookie.split('=')[1]
      config.headers['X-CSRFToken'] = csrfToken
    }
  }

  const demo = store.state.demo
  if (demo) {
    config.headers['DEMO'] = 1
  }

  if (store.state.brand.settings) {
    config.headers['X-Brand-ID'] = store.state.brand.settings.id
  }

  return config
}, function (error) {
  return Promise.reject(error)
})

export default client
